import PropTypes          from 'prop-types';
import { useTranslation } from 'next-i18next';
import Link               from 'next/link';
import isNull             from 'lodash/isNull';
import isEmpty            from 'lodash/isEmpty';
import cns                from 'classnames';
import { getHumanDate }   from 'helpers/helpers';
import styles             from './article-item.module.scss';

import CalendarIcon       from '@material-ui/icons/CalendarTodayOutlined';
import CameraIcon         from '@material-ui/icons/PhotoCameraTwoTone';
import TreeIcon           from '@material-ui/icons/AccountTreeOutlined';

function ArticleItem ({ data, size, showCategory }) {
  const { t } = useTranslation('common');

  return (
    <div className={styles.wrapper}>
      <Link
        href={{
          pathname: "/articles/[slug]",
          query: { slug: data.slug }
        }}
      >
        <a className={cns(styles.root, styles[size])}>
          <div
            className={cns(styles.preview, {
              [styles.hide_svg]: !isEmpty(data.photos)
            })}
            style={!isEmpty(data.photos) ? {backgroundImage: `url('${data.photos[0].file.url}?resize=1000x1000')`} : {}}
          >
            <CameraIcon/>

            <div className={styles.title}>
              {!isEmpty(data.title) ? data.title : t('article.emptyTitle')}
            </div>
          </div>

          <div className={styles.footer}>
            <div className={styles.date}>
              <CalendarIcon/>{getHumanDate(data.createdAt)}
            </div>

            <If condition={showCategory}>
              <div className={styles.category}>
                <TreeIcon/>
                <Choose>
                  <When condition={!isNull(data.articleCategory)}>
                    {data.articleCategory.name}
                  </When>
                  <Otherwise>
                    {t('common.article.category.empty')}
                  </Otherwise>
                </Choose>
              </div>
            </If>
          </div>
        </a>  
      </Link>
    </div>
  )
};

ArticleItem.propTypes = {
  size: PropTypes.oneOf(['normal', 'double']),
  showCategory: PropTypes.bool
};

ArticleItem.defaultProps = {
  size: 'normal',
  showCategory: true
};

export default ArticleItem;